import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=b3175a48&scoped=true"
import script from "./BankCard.vue?vue&type=script&lang=js"
export * from "./BankCard.vue?vue&type=script&lang=js"
import style0 from "./BankCard.vue?vue&type=style&index=0&id=b3175a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3175a48",
  null
  
)

export default component.exports